/**
 * The transcript download an audio tool page asks for, carried on the URL.
 *
 * /audio-to-text and the four other "to text" pages promise a text file, and /mp3-to-srt an SRT
 * (`transcript_format` on the row, src/formats/audio-tools.ts). The upload answers with the job
 * page's URL, the job page sends the visitor on to the transcript's when the job is done, and the
 * transcript page (`server/app/routes_pages.py`) puts the format named by `?download=` first: the
 * phone's sticky bar and the button above the download row. So the choice rides on both URLs as
 * one query parameter and nothing is stored anywhere.
 *
 * The server checks the value against the formats that transcript actually has and ignores
 * anything else. This side only refuses what could not be a format token at all, so a hand-edited
 * URL cannot smuggle anything longer through the job page.
 */

export const DOWNLOAD_PARAM = 'download';

/** The shape of a format token: `txt`, `srt`, `lrc-enhanced`. */
const TOKEN = /^[a-z][a-z-]{0,23}$/;

const RELATIVE = 'http://relative.invalid';

/** `url` with `?download={format}` set, or `url` untouched when there is no usable format. */
export function withDownload(url: string, format: string | null | undefined): string {
  if (!format || !TOKEN.test(format)) return url;
  const parsed = new URL(url, RELATIVE);
  parsed.searchParams.set(DOWNLOAD_PARAM, format);
  // The API's URLs are paths (`/t/{id}`), and a path must stay a path.
  return parsed.origin === RELATIVE
    ? `${parsed.pathname}${parsed.search}${parsed.hash}`
    : parsed.href;
}

/** The format a page's own query string names, or null. */
export function downloadFrom(search: string): string | null {
  const value = new URLSearchParams(search).get(DOWNLOAD_PARAM);
  return value && TOKEN.test(value) ? value : null;
}
